"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadImageTouchZoomHintFromLocalStorageSaga = loadImageTouchZoomHintFromLocalStorageSaga;
exports.loadImageTouchZoomHintFromLocalStorage = loadImageTouchZoomHintFromLocalStorage;
exports.disableImageTouchZoomHintSaga = disableImageTouchZoomHintSaga;
exports.disableImageTouchZoomHint = disableImageTouchZoomHint;
exports.default = productPreviewSaga;
const tslib_1 = require("tslib");
const common_utils_1 = require("@as-react/common-utils");
const effects_1 = require("redux-saga/effects");
const ActionEnums_1 = require("../../../enums/ActionEnums");
const LocalStorageUtil_1 = tslib_1.__importDefault(require("../../../util/LocalStorageUtil"));
const ProductPreviewActions_creators_1 = require("../actions/ProductPreviewActions.creators");
const LOCAL_STORAGE_IMAGE_TOUCH_ZOOM_HINT_KEY = 'imageTouchZoomHint';
function* loadImageTouchZoomHintFromLocalStorageSaga() {
    yield (0, effects_1.takeLatest)(ActionEnums_1.ProductActionTypes.INIT, loadImageTouchZoomHintFromLocalStorage);
}
function* loadImageTouchZoomHintFromLocalStorage() {
    try {
        let imageTouchZoomHint = LocalStorageUtil_1.default.getJsonItem(LOCAL_STORAGE_IMAGE_TOUCH_ZOOM_HINT_KEY);
        if ((0, common_utils_1.isNullOrUndefined)(imageTouchZoomHint)) {
            imageTouchZoomHint = true;
        }
        yield (0, effects_1.put)(ProductPreviewActions_creators_1.productPreviewActions.updateImageTouchZoomHint(imageTouchZoomHint));
    }
    catch (_a) { }
}
function* disableImageTouchZoomHintSaga() {
    yield (0, effects_1.takeLatest)(ActionEnums_1.ProductPreviewActionTypes.DISABLE_IMAGE_TOUCH_ZOOM_HINT, disableImageTouchZoomHint);
}
function* disableImageTouchZoomHint() {
    try {
        LocalStorageUtil_1.default.setItem(LOCAL_STORAGE_IMAGE_TOUCH_ZOOM_HINT_KEY, false);
        yield (0, effects_1.put)(ProductPreviewActions_creators_1.productPreviewActions.updateImageTouchZoomHint(false));
    }
    catch (_a) { }
}
function* productPreviewSaga() {
    yield (0, effects_1.all)([loadImageTouchZoomHintFromLocalStorageSaga(), disableImageTouchZoomHintSaga()]);
}
